module.exports = __webpack_public_path__ + "static/media/bike.28060b67.svg";